import DropDownInput from "components/Properties/InputComponents/DropDownInput";
import {NumberSliderInput} from "components/Properties/InputComponents/NumberInput";
import BaseComponent from "../BaseComponent";

const ToneMappingComponent = ({scene, dropdownOnChange, dropdownOpened, setDropdownOpened, inputOnChange}) => {
  const toneMapping = scene.userData.toneMapping;

  return (
    <BaseComponent title="Tone Mapping" foldable={true}>
      <DropDownInput
        name="ToneMappingMode"
        array={["None", "Linear", "Reinhard", "Cineon", "ACES Filmic"]}
        dropdownOnChange={dropdownOnChange}
        value={toneMapping.mode}
        dropdownOpened={dropdownOpened}
        setDropdownOpened={setDropdownOpened}
      />
      <NumberSliderInput name="Exposure" value={toneMapping.exposure || 0} max={2} min={0} step={0.1} inputOnChange={inputOnChange} />
    </BaseComponent>
  );
};

export default ToneMappingComponent;
